import { useState } from 'react'

import { useMessage } from '@/core'
import { Page } from '@/core/architecture'

import { MailAuthTemplate, SignUpAction, SignUpTemplate } from './template'
import { useViewModel } from './viewModel'

export const SignUp: Page = () => {
  const { state, actions } = useViewModel()
  const { showError } = useMessage()

  const [step, nextStep] = useState(0)

  const onSubmitSignUp: SignUpAction['onSubmitSignUp'] = inputs =>
    actions
      .signUp(inputs)
      .then(() => nextStep(1))
      .catch(e => {
        showError(e)
      })

  return [
    <SignUpTemplate
      state={state}
      onSubmitSignUp={onSubmitSignUp}
      onSignUpWithApple={actions.signUpWithApple}
      onSignUpWithGoogle={actions.signUpWithGoogle}
    />,
    <MailAuthTemplate
      state={state}
      onSubmitMailAuth={actions.verifyAccount}
      onResendAuthMail={actions.resendVerifyMail}
    />,
  ][step]
}
